import React from 'react';
import { Viewport, ViewSmall, ViewMedium } from '@shared-ui/viewport-context';

// Uitk components
import { UitkLayoutGrid } from 'uitk-react-layout-grid';

import { DealsSlickCarousel } from 'src/components/common/modules/expedia-deals/hotel/hotel-view/components/support/deal-carousel';
import { ItemKeyHelper } from 'src/components/common/helper';

export const gridSlickView = (dealsCarouselViewsProps, loadCampaign, renderDealsCampaignCard) => {
  const keyHelper = new ItemKeyHelper('DealsCampaign');
  return (
    <Viewport>
      <ViewSmall>
        <>
          {/* <DealsCarousel {...dealsCarouselViewsProps}  /> */}
          <DealsSlickCarousel {...dealsCarouselViewsProps} />
        </>
      </ViewSmall>
      <ViewMedium>
        <>
          <UitkLayoutGrid columns={{ medium: 2, extra_large: 3, small: 1 }} space="three">
            {loadCampaign?.map((offer, cardIndex) => {
              return (
                <React.Fragment key={keyHelper.next()}>{renderDealsCampaignCard(offer, cardIndex)}</React.Fragment>
              );
            })}
          </UitkLayoutGrid>
        </>
      </ViewMedium>
    </Viewport>
  );
};
